export enum AlignOptions {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}
